<h2 class="section-title-with-icon">
  <mat-icon svgIcon="coins" class="section-title-icon notranslate"></mat-icon>
  <span>Spend To Date</span>
</h2>
<!-- From updadted project budget -->
<ul class="details-list" *ngIf="asset.projectBudgetUpdated as budget">
  <li *ngIf="budget.acquisition != undefined">
    <label>Acquisition</label>
    <span>
      <span class="value">{{ budget.acquisition | terraCurrency }} </span>
      <span class="unit">{{ asset.initialCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="budget.hardCost != undefined">
    <label>Hard Cost</label>
    <span>
      <span class="value">{{ budget.hardCost | terraCurrency }} </span>
      <span class="unit">{{ asset.initialCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="budget.softCost != undefined">
    <label>Soft Cost</label>
    <span>
      <span class="value">{{ budget.softCost | terraCurrency }} </span>
      <span class="unit">{{ asset.initialCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="budget.financing != undefined">
    <label>Financing</label>
    <span>
      <span class="value">{{ budget.financing | terraCurrency }} </span>
      <span class="unit">{{ asset.initialCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="budget.totalCosts != undefined">
    <label>Total Costs</label>
    <span>
      <span class="value">{{ budget.totalCosts | terraCurrency }} </span>
      <span class="unit">{{ asset.initialCurrency.iso }}</span>
    </span>
  </li>
</ul>
